const styles = {
  form: {
    display: 'flex',
  },
  button: {
    marginLeft: 'auto',
  },
}

export default styles



// WEBPACK FOOTER //
// ./src/Containers/Form/City/CityPrograms/ProgramsForm/styles.js